import { CommonSwitchButton } from 'components/common/buttons/switch-button';
import { ErrorBoundary } from 'components/common/error-boundary';
import usePitchPerformanceStore from 'components/sections/admin-portal/machines/dialogs/pitch-performance/store/use-pitch-performance-store';

export const PitchPerfToggleThresholds = () => {
  const showThresholds = usePitchPerformanceStore((s) => s.showThresholds);

  return (
    <ErrorBoundary identifier="PitchPerfToggleThresholds">
      <CommonSwitchButton
        id="toggle-thresholds"
        displayTrue="Thresholds"
        displayFalse="Thresholds"
        value={showThresholds}
        onChange={(v) =>
          usePitchPerformanceStore.setState({ showThresholds: v })
        }
      />
    </ErrorBoundary>
  );
};
